import { Redirect } from "react-router";
import { useClubHouse } from "../../context";
import { LoginForm } from "../Login";

export const SingleDayViewActivation = () => {
    const { inClubMode, authorize } = useClubHouse()

    return inClubMode ? <Redirect to="/" /> : <LoginForm login={authorize} />
}